<template>
  <fragment>
    <!-- CONTACT FORM START -->
    <v-container class="my-5">
      <v-row>
        <v-col cols="12">
          <v-card style="overflow: hidden;" elevation="3">
            <v-card-text class="pa-0">
              <v-row class="ma-0">
                <v-col cols="12" md="5" class="pa-0" :style="cn === 'A52S' ? 'background-color: #ffffff;' : 'background-color: #f4f4f4;'">
                  <v-img :src="`${publicPath}images/samsung/${image}`" class="align-stretch" contain
                         height="100%" aspect-ratio="1.479" position="center center">
                    <div class="d-flex flex-column justify-space-between py-6 order-summary" style="height: 100%;">
                      <!--<v-icon color="white" x-large v-show="$vuetify.breakpoint.mdAndUp">
                        mdi-email
                      </v-icon>-->
                      <div class="white--text text-center white--text">
                        <v-row justify="center" v-if="$store.state.GeneralManagement.calcData">
                          <v-col cols="12">
                            <div class="headline">
                              Device details:
                            </div>
                          </v-col>
                          <v-col cols="12">
                            <div class="title font-weight-bold">
                              {{ this.$store.state.GeneralManagement.calcData.brandName }} {{ this.$store.state.GeneralManagement.calcData.deviceName }}
                            </div>
                          </v-col>
                          <v-col cols="12" v-for="(value, name, index) in $store.state.GeneralManagement.calcData.damage" :key="index">
                            <v-row>
                              <v-col v-if="name == 'screen'" cols="6" class="text-center">
                                Kijelző:
                              </v-col>
                              <v-col v-if="name == 'battery'" cols="6" class="text-center">
                                Akkumulátor:
                              </v-col>
                              <v-col v-if="name == 'cover'" cols="6" class="text-center">
                                Hátlap/Keret:
                              </v-col>
                              <v-col v-if="name == 'deviceStatus'" cols="6" class="text-center">
                                Készülék állapota:
                              </v-col>
                              <v-col v-if="name == 'networkLock'" cols="6" class="text-center">
                                Hálózati zár:
                              </v-col>
                              <v-col cols="6" class="text-center">
                                {{ value }}
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                        <v-row v-else>
                          <v-col cols="12">
                            <div class="title">
                              A készülék adatok nem elérhetők
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                      <div class="white--text text-center headline align-self-center">
                        {{ $t('ourEmail') }}:<br><a class="body-1 white--text">info@tmx.hu</a>
                      </div>
                      <!--<v-icon color="white" x-large v-show="$vuetify.breakpoint.mdAndUp">
                        mdi-phone
                      </v-icon>-->
                      <div class="white--text text-center headline align-self-center">
                        {{ $t('ourPhoneNumber') }}:<br><a class="body-1 white--text">+36-1/585-8381</a>
                      </div>
                    </div>
                  </v-img>
                </v-col>
                <v-col cols="12" md="7" class="px-10 py-12">
                  <v-form v-model="contactFormIsValid">
                    <v-row>
                      <v-col cols="12" md="6" class="py-2">
                        <v-text-field v-model="customerData.lastName"
                                      :label="$t('inputLabels.lastName')"
                                      counter="30"
                                      outlined
                                      disabled>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" md="6" class="py-2">
                        <v-text-field v-model="customerData.firstName"
                                      :label="$t('inputLabels.firstName')"
                                      counter="30"
                                      outlined
                                      disabled>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" md="6" class="py-2">
                        <v-text-field v-model="customerData.email"
                                      :label="$t('inputLabels.email')"
                                      counter="30"
                                      outlined
                                      disabled>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" md="6" class="py-2">
                        <v-text-field v-model="customerData.phone"
                                      :label="$t('inputLabels.phone')"
                                      prefix="+36-"
                                      v-mask="mask"
                                      outlined
                                      disabled>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" class="py-0 mb-5">
                        <v-divider></v-divider>
                      </v-col>
                      <v-col cols="12" md="6" class="py-2">
                        <v-text-field v-model="customer.taxNumber"
                                      :label="$t('inputLabels.ado')"
                                      :rules="inputRules.taxRules"
                                      counter="10"
                                      maxlength="10"
                                      v-mask="taxMask"
                                      outlined>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" md="6" class="py-2">
                        <v-text-field v-model="customer.accountNumber"
                                      :label="$t('inputLabels.accountNumber')"
                                      :rules="inputRules.phoneRules"
                                      :hint="$t('inputMessages.requiredField')"
                                      persistent-hint
                                      counter="26"
                                      maxlength="26"
                                      v-mask="bankAccountMask"
                                      outlined
                                      required>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" class="py-0 mb-5">
                        <v-divider></v-divider>
                      </v-col>
                      <!-- CÍM ADATOK START -->
                      <v-col cols="12">
                        <div class="headline">
                          Elszállítási cím:
                        </div>
                      </v-col>
                      <v-col cols="12" md="6" class="py-2">
                        <v-autocomplete v-model="customer.zipCode"
                                        :items="selectFieldOptions.postalCodes"
                                        item-text="address.postalCode"
                                        item-value="address.postalCode"
                                        :search-input.sync="postalCodeSearch"
                                        :label="$t('inputLabels.postalCode')"
                                        :rules="inputRules.phoneRules"
                                        :hint="$t('inputMessages.requiredField')"
                                        :no-data-text="$t('inputMessages.noDataText')"
                                        persistent-hint
                                        outlined
                                        maxlength="4"
                                        required
                                        @change="onPostalCodeSelect"
                                        @click:clear="clearAllAddressInputs"
                                        clearable>
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="6" class="py-2">
                        <v-autocomplete v-model="customer.city"
                                        :items="selectFieldOptions.cities"
                                        item-value="address.city"
                                        item-text="address.city"
                                        :search-input.sync="citySearch"
                                        :label="$t('inputLabels.city')"
                                        :rules="inputRules.generalRules"
                                        :hint="$t('inputMessages.requiredField')"
                                        :no-data-text="$t('inputMessages.noDataText')"
                                        persistent-hint
                                        outlined
                                        required
                                        clearable
                                        @click:clear="clearAllAddressInputs">
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="6" class="py-2">
                        <v-combobox v-model="streetIdeiglenes"
                                    :items="selectFieldOptions.streets"
                                    item-value="address.street"
                                    item-text="address.street"
                                    :search-input.sync="streetSearch"
                                    :label="$t('inputLabels.publicPlaceName')"
                                    :rules="inputRules.generalRules"
                                    :hint="$t('inputMessages.requiredField')"
                                    :no-data-text="$t('inputMessages.noDataText')"
                                    persistent-hint
                                    outlined
                                    required
                                    @change="onPublicPlaceSelect"
                                    clearable>
                        </v-combobox>
                      </v-col>
                      <v-col cols="12" md="6" class="py-2">
                        <v-text-field v-model="customer.streetNumber"
                                      :label="$t('inputLabels.streetNumber')"
                                      :rules="inputRules.generalRules"
                                      :hint="$t('inputMessages.requiredField')"
                                      :no-data-text="$t('inputMessages.noDataText')"
                                      persistent-hint
                                      outlined
                                      required
                                      clearable>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" class="py-2">
                        <v-textarea v-model="customer.otherAddressInfo"
                                    :label="$t('inputLabels.other')"
                                    outlined
                                    maxlength="50"
                                    counter="50"
                                    required
                                    clearable>
                        </v-textarea>
                      </v-col>
                      <!-- CÍM ADATOK END -->
                      <v-col cols="12">
                        <p class="body-2">
                          {{ $t('shippingDisclaimer') }}
                        </p>
                      </v-col>
                      <v-col cols="12">
                        <v-row justify="end">
                          <v-btn large color="primary" :disabled="!contactFormIsValid" @click="sendCustomerAdditionalData">
                            {{ $t('button.send') }}
                          </v-btn>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <!-- CONTACT FORM END -->
    <!-- RESPONSE DIALOGS START -->
    <v-dialog v-model="loadingDialog.visible" width="90%" max-width="440" :persistent="true">
      <loading-dialog v-bind:loading-message="loadingDialog.message" />
    </v-dialog>
    <v-dialog v-model="responseDialog.visible" width="90%" max-width="440" :persistent="true">
      <response-dialog v-bind:response-object="responseDialog.response"
                       v-on:close-dialog="closeResponseDialog"/>
    </v-dialog>
    <!-- RESPONSE DIALOGS END -->
  </fragment>
</template>

<script>
import responseDialog from './responseDialog.vue';
import loadingDialog from './loadingDialog.vue';
import {
  HEREGETPOSTALCODESBYCOUNTRY,
  HEREGETCITYBYPOSTALCODE,
  HEREGETSTREETBYPOSTALCODE,
} from '../utils/hereAPI';

export default {
  name: 'ShippingInformationsForm',
  props: {
    formBackgroungImage: String,
    formLogo: String,
    linkTo: String,
  },
  components: {
    responseDialog, loadingDialog,
  },
  beforeMount() {
    this.cn = this.$store.getters.getCampaignName;
    if (this.cn === 'A52S') {
      this.image = 'samsung-a52s-MO-v2.jpg';
    }
  },
  mounted() {
    this.contactForm.sourceSystem = this.$route.name.substring(14);
  },
  data() {
    return {
      cn: 'A52S',
      customerData: {
        firstName: this.$store.state.GeneralManagement.customerData.firstName,
        lastName: this.$store.state.GeneralManagement.customerData.lastName,
        phone: this.$store.state.GeneralManagement.customerData.phone,
        email: this.$store.state.GeneralManagement.customerData.email,
        /* firstName: 'John',
        lastName: 'Doe',
        phone: '20-123-4567',
        email: 'john@email.com', */
      },
      customer: {
        calcDataId: this.$store.state.GeneralManagement.customerData.calcDataId,
        customerId: this.$store.state.GeneralManagement.customerData.customerId,
        /* calcDataId: 123,
        customerId: 45, */
        statusId: 30,
        taxNumber: '',
        accountNumber: '',
        countryCode: 'HUN',
        countryLabel: 'Magyarország',
        city: '',
        zipCode: '',
        publicPlaceName: '',
        publicPlaceType: '',
        streetNumber: '',
        otherAddressInfo: '',
      },
      mask: '##-###-####',
      bankAccountMask: '########-########-########',
      taxMask: '##########',
      modal: false,
      contactFormIsValid: false,
      imeiHint: '',
      loadingDialog: {
        visible: false,
        message: '<div class="display-1"><b>Küldés folyamatban!</b></div><div class="headline mb-4">Kérlek várj türelemmel.</div>',
      },
      responseDialog: {
        visible: false,
        response: {
          error: false,
          message: null,
        },
      },
      countrySearch: '',
      countrySearchIsLoading: false,
      postalCodeSearch: '',
      postalCodeSearchIsLoading: false,
      citySearch: '',
      citySearchIsLoading: false,
      streetSearch: '',
      streetSearchIsLoading: false,
      streetIdeiglenes: '',
      selectFieldOptions: {
        countries: [
          { label: 'Magyarország', countryCode: 'HUN' },
        ],
        countriesEN: [
          { label: 'Hungary', countryCode: 'HUN' },
        ],
        countriesDE: [
          { label: 'Ungarn', countryCode: 'HUN' },
        ],
        postalCodes: [
          { header: this.$t('inputMessages.startTypingPostalCode') },
        ],
        cities: [
          { header: this.$t('inputMessages.startTypingCity') },
        ],
        streets: [
          { header: this.$t('inputMessages.startTypingStreet') },
        ],
      },
      inputRules: {
        generalRules: [v => !!v || this.$t('inputMessages.requiredField')],
        emailRules: [
          v => /.+@.+\..+/.test(v) || this.$t('inputMessages.emailMatch'),
          v => !!v || this.$t('inputMessages.requiredField'),
        ],
        phoneRules: [
          v => /^[0-9\-]*$/.test(v) || this.$t('inputMessages.onlyNumbers'),
          v => !!v || this.$t('inputMessages.requiredField'),
        ],
        taxRules: [
          v => /^[0-9]*$/.test(v) || this.$t('inputMessages.onlyNumbers')
        ]
      },
      publicPath: process.env.BASE_URL,
      campaignName: this.$store.state.GeneralManagement.calcData.campaignName,
      image: 'mainSliderMOBFoldFlip2022v2.jpg',
    };
  },
  methods: {
    async sendCustomerAdditionalData() {
      this.openLoadingDialog();
      const response = await this.$store.dispatch('sendAdditionalCustomerData', this.customer);
      if (response === 201) {
        this.responseDialog.response.message = `<div class="display-1 mb-6"><b>Sikeres beküldés!</b></div><div class="headline mb-4">Sikeresen elfogadtad az árajánlatunkat! Hamarosan küldjük a futárt a készülékedért a megadott címre!</div><div class="mb-4">A szállítással kapcsolatos információkért <a href="/hogyan-mukodik#szallitas" target="_self">kattints ide</a> vagy olvasd el a GYIK 11-es pontját.</div><div>Köszönjük, hogy minket választottál!</div>`;
      } else if(response === 405) {
        this.responseDialog.response.message = '<div class="display-1 mb-6"><b>Érvénytelen HTTP hívás</b></div><div class="headline mb-4">A folyamat során váratlan hiba lépett fel!<br>Dolgozunk a hiba elhárításán!</div><div>Köszönjük türelmét!</div>';
      } else {
        this.responseDialog.response.message = '<div class="display-1 mb-6"><b>Szerver hiba</b></div><div class="headline mb-4">A folyamat során váratlan hiba lépett fel!<br>Dolgozunk a hiba elhárításán!</div><div>Köszönjük türelmét!</div>';
      }
      this.controlDialogs();
    },
    openLoadingDialog() {
      this.loadingDialog.visible = true;
    },
    closeLoadingDialog() {
      this.loadingDialog.visible = false;
    },
    openResponseDialog() {
      this.responseDialog.visible = true;
    },
    closeResponseDialog() {
      this.responseDialog.visible = false;
      if (this.campaignName === 'A52S') {
        this.$router.push({ name: 'estore-voucher-a52-home' });
      } else {
        this.$router.push('/');
      }
    },
    controlDialogs() {
      setTimeout(this.closeLoadingDialog, 3000);
      setTimeout(this.openResponseDialog, 3200);
    },
    /**
       * Irányítószám ország alapján API
       */
    async getPostalCodesByCountry(value) {
      const response = await HEREGETPOSTALCODESBYCOUNTRY(value, this.customer.countryCode);
      if (!response.error) {
        this.selectFieldOptions.postalCodes = response.data;
        this.postalCodeSearchIsLoading = false;
        this.selectFieldOptions.postalCodes.unshift({ header: this.$t('inputMessages.startTypingPostalCode') });
        /* if (this.selectFieldOptions.postalCodes.length === 1) {
            this.onPostalCodeSelect();
          } */
      }/* else {
        this.selectFieldOptions.postalCodes = [];
      } */
    },
    /**
       * Város Irányítószám és ország alapján API
       */
    async getCityByPostalCode() {
      let postalcode = 0;
      if (this.customer.zipCode.address) {
        postalcode = this.customer.zipCode.address.postalCode;
        this.customer.zipCode = postalcode;
      }
      const response = await HEREGETCITYBYPOSTALCODE(this.customer.zipCode, this.customer.countryCode);
      if (!response.error) {
        this.selectFieldOptions.cities = response.data;
        this.citySearchIsLoading = false;
        this.selectFieldOptions.cities.unshift({ header: this.$t('inputMessages.startTypingCity') });
      }
    },
    /**
       * Utca API
       */
    async getStreetByPostalCode(value) {
      const response = await HEREGETSTREETBYPOSTALCODE(value, this.customer.zipCode, this.customer.countryCode);
      if (!response.error) {
        this.selectFieldOptions.streets = response.data;
        this.streetSearchIsLoading = false;
        this.selectFieldOptions.streets.unshift({ header: this.$t('inputMessages.startTypingStreet') });
      }
    },
    /**
       * Város autocomplete ha kiválasztottuk az irányítószámot
       */
    async onPostalCodeSelect() {
      await this.getCityByPostalCode();
      if (this.selectFieldOptions.cities.length === 2) {
        this.customer.city = this.selectFieldOptions.cities[1].address.city;
        this.citySearch = this.selectFieldOptions.cities[1].address.city;
      }
      this.customer.publicPlaceName = '';
      this.customer.publicPlaceType = '';
      this.customer.streetNumber = '';
      this.streetIdeiglenes = '';
      this.streetSearch = null;
    },
    onPublicPlaceSelect() {
      let street = '';
      let type = '';
      if (this.streetIdeiglenes.length > 0) {
        street = this.streetIdeiglenes.substring(0, this.streetIdeiglenes.lastIndexOf(' '));
        type = this.streetIdeiglenes.substring(this.streetIdeiglenes.lastIndexOf(' '), this.streetIdeiglenes.length + 1).trim();
      } else if (this.streetIdeiglenes.address) {
        street = this.streetIdeiglenes.address.street.substring(0, this.streetIdeiglenes.address.street.lastIndexOf(' '));
        type = this.streetIdeiglenes.address.street.substring(this.streetIdeiglenes.address.street.lastIndexOf(' '), this.streetIdeiglenes.address.street.length + 1).trim();
      }
      this.customer.publicPlaceName = street;
      this.customer.publicPlaceType = type;
    },
    clearAllAddressInputs() {
      this.selectFieldOptions.postalCodes = [
        { header: this.$t('inputMessages.startTypingPostalCode') },
      ];
      this.selectFieldOptions.cities = [
        { header: this.$t('inputMessages.startTypingCity') },
      ];
      this.selectFieldOptions.streets = [
        { header: this.$t('inputMessages.startTypingStreet') },
      ];
      this.postalCodeSearch = '';
      this.postalCodeSearchIsLoading = false;
      this.citySearch = '';
      this.citySearchIsLoading = false;
      this.streetSearch = '';
      this.streetSearchIsLoading = false;
      this.streetIdeiglenes = '';
      this.customer.zipCode = '';
      this.customer.city = '';
      this.customer.publicPlaceType = '';
      this.customer.publicPlaceName = '';
      this.customer.streetNumber = '';
    },
  },
  watch: {
    postalCodeSearch(value) {
      this.postalCodeSearchIsLoading = true;
      this.getPostalCodesByCountry(value);
    },
    streetSearch(value) {
      this.streetSearchIsLoading = true;
      this.getStreetByPostalCode(value);
    },
  },
};
</script>

<style scoped>

</style>
